/*
 * 配置文件
 * #####################################################################
 * # 注意：本配置文件需要提交到发布服务器上
 * # 保持变量的赋值为空值，除非有新变量的产生，请不要提交到git上去
 * # 可以使用config.development.js文件替代
 * #####################################################################
 * Copyright (c) 2018. supOS
 */

const configProduction = {
  domainMenu: '',
  domain: '',
  domain1: '',
  domain2: '',
  domain3: '',
  domain8: '',
  domain4: '',
  domain5: '',
  domain6: '',
  domain7: '',
  domain9: '',
  domain10: '',
  domain12: '/api/runtime',
  domain11: '',
  domainObject: '/api/compose/manage',
  domainObjectSelect: '',
  domainWorkShop: '/project/workshop/#/',
  domainShield: '/project/shield/#/',
  domainIndustryApplication: '/api/compose/manage',
  collectorDomain: '',
  domainWS: `${location.host}`, // websock地址
  version: '0.1',
  domainPrefix: location.origin,
  environment: 'prod' //* 由于 app-creator 拆包原因 , 为方便开发人员 通过 config.environment 指定不同的页面
};

export default configProduction;
